module.exports = "./img/25d9ecb1417a5fc7cdd3605757747364.jpg";